import { omitKeys } from '@adsk/alloy-react-helpers';

import { GroupedItemKeys } from '../types';

export default (
  item1?: Record<string, unknown> | null,
  item2?: Record<string, unknown> | null
): boolean => {
  // These keys are added by useGroupeditems and can change their value for the same object
  // so let's ignore them during this comparison
  const groupedItemKeys: (keyof GroupedItemKeys)[] = ['groupKey', 'index'];

  return (
    JSON.stringify(omitKeys(item1 as GroupedItemKeys, groupedItemKeys)) ===
    JSON.stringify(omitKeys(item2 as GroupedItemKeys, groupedItemKeys))
  );
};
